import axios from "axios";
import { silentRequest } from "../authConfig";

const API_URL = process.env.REACT_APP_API_URL;

/**
 * @function UploadFile upload user's signature
 * @param {Object} payload {instance, account, selectedFile, name}
 * @returns {Promise} data
 */
export const UploadFile = (payload) => {
  return new Promise((resolve, reject) => {
    payload.instance
    .acquireTokenSilent({ ...silentRequest, account: payload.account })
    .then((tokenResponse) => {
      let promises = [];
      let formData = new FormData();

      formData.append("file", payload.selectedFile);
      formData.append("fileName", new Blob([JSON.stringify({
        name: payload.name || "untitled.svg"
      })], {
        type: "application/json"
      }));

      promises.push(
        axios.post(API_URL + "/signatures", formData, {
          headers: {
            Authorization: "Bearer " + tokenResponse.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
      );

      Promise.all(promises).then(function (results) {
        // console.log("Response upload: ", results[0].data);
        resolve(results[0].data);
      });
    })
    .catch((error) => {
      console.log(error);
      payload.instance.acquireTokenRedirect(silentRequest);
      reject();
    });
  })
  
}
